import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "step__subtitle" }
const _hoisted_2 = { class: "step-row__tags" }

import StepRowInformation from '@/brief-hub/deposit/overview/StepRowInformation.vue';
    import {TJoyTagVariants} from '@maltjoy/core-vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StepRowTags',
  props: {
    label: {},
    tags: {},
    mandatory: { type: Boolean, default: false },
    variant: { default: 'primary' }
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  const _component_VJoyTag = _resolveComponent("VJoyTag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.tags?.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.tags, (tag) => {
            return (_openBlock(), _createBlock(_component_VJoyTag, {
              key: tag,
              variant: _ctx.variant,
              label: tag,
              class: "step-row__tag"
            }, null, 8, ["variant", "label"]))
          }), 128))
        : (_openBlock(), _createBlock(StepRowInformation, {
            key: 1,
            mandatory: _ctx.mandatory
          }, null, 8, ["mandatory"]))
    ])
  ], 64))
}
}

})